<template>
  <div class="role-list">
    <Collapse simple v-model="tableToolsPanel" class="table-tools-panel" accordion>
      <Panel name="filter" hide-arrow>
        <div class="table-tools-panel-title"><Icon class="table-tools-panel-title-icon" type="ios-funnel" />筛选</div>
        <div class="pull-right">
          <Tooltip content="刷新结果">
            <Button @click.stop="refresh" type="text" size="large" icon="ios-refresh"></Button>
          </Tooltip>
          <Divider type="vertical" />
          <Tooltip :content="(tableToolsPanel.indexOf('filter')>-1? '隐藏':'展开')+'筛选条件'">
            <Button type="text" size="large" :icon="tableToolsPanel.indexOf('filter')>-1? 'ios-arrow-up':'ios-arrow-down'"></Button>
          </Tooltip>
        </div>
        <div slot="content">
          <div class="padding-top-20"></div>
          <Form ref="filterForm" :model="filterModel" inline :show-message="false" :label-width="110">
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="名称" prop="name">
                  <Input v-model="filterModel.name" placeholder="输入名称" />
                </FormItem>
              </i-col>
              <i-col span="8">
                <FormItem label="系统预设" prop="isReserved">
                  <RadioGroup v-model="filterModel.isReserved" type="button">
                    <Radio :label="null">不限</Radio>
                    <Radio :label="1">预设</Radio>
                    <Radio :label="0">非预设</Radio>
                  </RadioGroup>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="8">
                <FormItem label="用户类型" prop="type">
                  <Select v-model="filterModel.type" filterable>
                    <Option v-for="(tp,idx) in $common.getEnumSelect($common.userType)" :key="idx" :value="parseInt(tp.key)">{{tp.value}}</Option>
                  </Select>
                </FormItem>
              </i-col>
            </Row>
            <Row :gutter="8">
              <i-col span="16">
                <FormItem style="width: 100%; text-align:right">
                  <Button type="primary" size="large" style="width:144px;" @click="refresh">查询</Button>
                  <Divider type="vertical" />
                  <Button type="error" ghost size="large" @click="$refs['filterForm'].resetFields()">重置</Button>
                </FormItem>
              </i-col>
            </Row>
          </Form>
        </div>
      </Panel>
    </Collapse>
    <div class="padding-top-10"></div>
    <div class="text-right">
      <Button type="primary" to="/roles/new" icon="md-add">新增角色</Button>
    </div>
    <div class="padding-top-10"></div>
    <!-- <Alert type="success" show-icon><b>导入完成！</b>成功 1 条，失败 0 条。</Alert> -->
    <Table border ref="dataTable"
      size="small"
      stripe
      :columns="columns"
      @on-sort-change="tableSortChange"
      :data="data">
    </Table>
    <Page class="pager"
      :total="totalCount"
      :current="currentPageIndex"
      @on-change="changePageIndex"
      @on-page-size-change="changePageSize"
      size="small"
      show-elevator
      show-total
      show-sizer />
  </div>
</template>

<script>
export default {
  name: 'role-list',
  props: {
  },
  data () {
    return {
      tableToolsPanel: '',
      columns: [
        {
          title: '名称',
          key: 'name',
          resizable: true,
          sortable: 'custom',
          sortMethod: (a, b, type) => {
            if (type === 'asc') {
              return a.localeCompare(b, 'zh-CN')
            } else {
              return b.localeCompare(a, 'zh-CN')
            }
          }
        },
        {
          title: '角色类别',
          key: 'type',
          resizable: true,
          width: 150,
          sortable: 'custom',
          render: (h, params) => {
            return h('span', null, this.$common.userType[params.row.type.toString()])
          }
        },
        {
          title: '父角色',
          key: 'parentName',
          resizable: true,
          width: 150,
          sortable: 'custom'
        },
        {
          title: '系统预设',
          key: 'isReserved',
          sortable: 'custom',
          render: (h, params) => {
            return h('Tag', {
              props: {
                // type: 'dot',
                color: !params.row.isReserved ? 'default' : 'primary'
              }
            }, !params.row.isReserved ? '非预设' : '预设')
          }
        },
        {
          title: '操作',
          width: 150,
          render: (h, params) => {
            let actions = [
              h('Tooltip', {
                props: {
                  content: '设置权限',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'primary',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-list-box'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'role-basic-permissions', params: {role: params.row}})
                    }
                  }
                }, null)
              ]),
              h('span', null, ' '),
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, [
                h('Button', {
                  props: {
                    type: 'warning',
                    ghost: true,
                    shape: 'circle',
                    icon: 'md-create'
                  },
                  on: {
                    click: () => {
                      // let userId = params.row.id
                      this.$router.push({name: 'role-edit', params: {role: params.row}})
                    }
                  }
                }, null)
              ])
            ]
            if (!params.row.isReserved) {
              actions.push(h('span', null, ' '))
              actions.push(
                h('Tooltip', {
                  props: {
                    content: '删除',
                    transfer: true
                  }
                }, [
                  h('Button', {
                    props: {
                      type: 'error',
                      ghost: true,
                      shape: 'circle',
                      icon: 'ios-trash-outline'
                    },
                    on: {
                      click: () => {
                        let roleId = params.row.tid
                        this.deleteRole(roleId)
                      }
                    }
                  }, null)
                ])
              )
            }
            return h('span', null, [
              h('Tooltip', {
                props: {
                  content: '修改',
                  transfer: true
                }
              }, actions)
            ])
          }
        }
      ],
      data: [],
      pageSize: 10,
      totalCount: 0,
      currentPageIndex: 1,
      filterModel: {
        name: null,
        type: null,
        isReserved: null
      },
      departments: [],
      curDepartmentId: null
    }
  },
  watch: {
    currentPageIndex: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
    pageSize: function (newVal) {
      if (newVal) {
        this.initData()
      }
    },
  },
  mounted () {
    this.initData()
  },
  activated () {
  },
  deactivated () {
  },
  methods: {
    refresh () {
      // console.log('123')
      this.initData()
    },
    changePageSize (e) {
      this.pageSize = e
    },
    changePageIndex (e) {
      this.currentPageIndex = e
    },
    tableSortChange (e) {
      if (e.key) {
        this.filterModel.sortBy = e.column.sortKey || e.key
        this.filterModel.ascending = e.order === 'normal' ? null : e.order == 'asc' ? true : false
        this.initData()
      }
    },
    async initData () {
      this.$Spin.show()
      let res = await this.$Api.Role.listRoles(this.filterModel, this.currentPageIndex, this.pageSize).catch(err => {
        this.$Message.error(err.message)
        this.$Spin.hide()
      })
      this.totalCount = res.totalCount
      this.currentPageIndex = res.currentPage
      this.pageSize = res.pageSize
      this.data = res.data
      this.$Spin.hide()
    },
    async deleteRole (roleId) {
      this.$Modal.confirm({
        title: '确认操作',
        content: '<p>确认删除该角色么？</p>',
        onOk: async () => {
          // this.$Spin.show()
          await this.$Api.Role.deleteRole(roleId).catch(err => {
            this.$Notice.error({
              title: '操作失败!',
              desc: err.message
            })
            // this.$Spin.hide()
            return null
          })
          this.$Message.success('操作成功!')
          this.data.splice(this.data.findIndex(o => {return o.id === roleId}), 1)
          this.totalCount -= 1
        },
        onCancel: () => {
        }
      })
    }
  }
}
</script>

<style lang="less" scoped>
.table-tools-panel {
  .table-tools-panel-title {
    font-weight: bold;
    display: inline-block;
  }
  .table-tools-panel-title-icon {
    margin-right: 20px;
  }
  .table-tools-panel-title-addon {
    display: inline-block;
    margin-left: 20px;
  }
}
.pager {
  margin: 20px 0;
}
</style>
